import { render, staticRenderFns } from "./WorldViewEditPage.vue?vue&type=template&id=619ac7e4&scoped=true"
import script from "./WorldViewEditPage.vue?vue&type=script&lang=ts"
export * from "./WorldViewEditPage.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewEditPage.vue?vue&type=style&index=0&id=619ac7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619ac7e4",
  null
  
)

export default component.exports